export const ROUTE = {
  INTRO: "/intro",
  SCAN: "/scan",
  SCANNED: "/scanned",
  YOUWIN: "/youwin",
  YOULOSE: "/youlose",
  WINNER: "/winner",
  RECORD: "/record",
  ANIMA: "/anima",
  LOGIN: "/login",
  PRIVATE: "/private",
  HOME: "/",
  AUTHFB: "/auth-fb",
  AUTHGOOGLE: "/auth-google",
  TERMS: "/terms",
  PRIVACY: "/privacy-policy",
  LOGINOTHER: "/login-other",
  PCSTEP: "/pcstep",
  END: "/end",
};